import Dashboard from '../modules/dashboard/Dashboard';
import Projects from '../modules/projects/Projects';
import Reporting from '../modules/reporting/Reporting';
import Employee from '../modules/employees/Employees';
import Lms from '../modules/lms/LMS';
import Notification from '../modules/notification/Notification';
import RoleManagemet from '../modules/roles/RoleManagement';
import RoleDetails from '../modules/roles/RoleDetails';
import SubAdmin from '../modules/sub-admin/SubAdmin';
import ProjectDetails from '../modules/projects/ProjectDetails';
import ViewEmployee from '../modules/employees/view-employee/ViewEmployee';
import ChangeRequest from '../modules/projects/changeRequest/ChangeRequest';
import Milestone from '../modules/projects/milestone/Milestone';
import LeaveDetail from '../modules/lms/LeaveDetail';
import ClientRoot from '../modules/client/ClientRoot';
import ClientInfo from '../modules/client/ClientInfo';
import MyProfile from '../modules/myProfile/MyProfile';
import Requests from '../modules/leaveRequest/Requests';
import RequestDetails from '../modules/leaveRequest/RequestDetails';
import EmployeeCollections from '../modules/employees/view-employee/components/EmployeeCollections';
import Hms from '../modules/hms/HMS';
import HmsDetails from '../modules/hms/details/HmsDetails';
import ViewReporting from '../modules/reporting/ViewReporting';
import BillingIds from '../modules/billingIds/BillingIds';
import SalaryRecord from '../modules/salary/SalaryRecord';
import Leads from '../modules/leads/Leads';
import EmployeeLeavesDetail from '../modules/employees/EmployeeLeavesDetail';
import Reports from '../modules/reports/Reports';
import ViewReport from '../modules/reports/ViewReport';

export const appRoutes = [
  { path: '/dashboard', Comp: <Dashboard />, routeName: 'dashboard', name: 'Dashboard' },
  { path: '/project', Comp: <Projects />, routeName: 'projects', name: 'Projects' },
  { path: '/reporting', Comp: <Reporting />, routeName: 'reporting', name: 'Reporting' },
  { path: '/employee', Comp: <Employee />, routeName: 'employee', name: 'Employees' },
  { path: '/lms', Comp: <Lms />, routeName: 'lms', name: 'Leave Management System' },
  {
    path: '/requests',
    Comp: <Requests />,
    routeName: 'requests',
    name: 'Leave Requests'
  },
  {
    path: '/requests/details',
    Comp: <RequestDetails />,
    routeName: 'requests'
  },
  {
    path: '/lms/details',
    Comp: <LeaveDetail />,
    routeName: 'lms'
  },
  {
    path: '/hms/details',
    Comp: <HmsDetails />,
    routeName: 'hms',
    name: 'Hardware Management System'
  },
  {
    path: '/notification',
    Comp: <Notification />,
    routeName: 'notifications',
    name: 'Notification'
  },
  { path: '/roles', Comp: <RoleManagemet />, routeName: 'roles', name: 'Role Management' },
  { path: '/clients', Comp: <ClientRoot />, routeName: 'clients', name: 'Clients' },
  { path: '/clients/info', Comp: <ClientInfo />, routeName: 'clients', name: 'Client' },
  {
    path: '/change-request',
    Comp: <ChangeRequest />,
    routeName: 'projects',
    name: 'Change Request'
  },
  {
    path: '/view-employee',
    Comp: <ViewEmployee />,
    routeName: 'employee',
    name: 'View Employee'
  },
  {
    path: '/view-employee/leave',
    Comp: <EmployeeLeavesDetail />,
    routeName: 'employee',
    name: 'Employee Leave Detail'
  },
  {
    path: '/view-employee/collection',
    Comp: <EmployeeCollections />,
    routeName: 'employee',
    name: 'View Employee'
  },
  { path: '/profile/:id?', Comp: <ViewEmployee />, routeName: 'employee', name: 'View Employee' },
  {
    path: '/view-report',
    Comp: <ViewReporting />,
    routeName: 'reporting',
    name: 'View Report'
  },
  {
    path: '/create-milestone',
    Comp: <Milestone />,
    routeName: 'projects',
    name: 'Create Milestone'
  },
  { path: '/roles/role/:id?', Comp: <RoleDetails />, routeName: 'roles' },
  { path: '/project/details', Comp: <ProjectDetails />, routeName: 'projects' },
  {
    path: '/project/details/collection',
    Comp: <EmployeeCollections />,
    routeName: 'projects',
    name: 'View projects'
  },
  {
    path: '/hms/details/collection',
    Comp: <EmployeeCollections />,
    routeName: 'hms',
    name: 'Hardware Management System'
  },
  { path: '/sub-admin', Comp: <SubAdmin />, routeName: 'subadmin', name: 'Sub Admin' },
  {
    path: 'my-profile',
    Comp: <MyProfile />,
    routeName: 'myprofile',
    name: 'My Profile'
  },
  {
    path: 'my-profile/collection',
    Comp: <EmployeeCollections />,
    routeName: 'myprofile',
    name: 'My Profile'
  },
  { path: '/hms', Comp: <Hms />, routeName: 'hms', name: 'Hardware Management System' },
  { path: '/billingIds', Comp: <BillingIds />, routeName: 'billing ids', name: 'Billing IDs' },
  {
    path: '/salary-records',
    Comp: <SalaryRecord />,
    routeName: 'salary-records',
    name: 'Salary Records'
  },
  {
    path: '/leads',
    Comp: <Leads />,
    routeName: 'leads',
    name: 'Leads'
  },
  {
    path: '/reports',
    Comp: <ViewReport />,
    routeName: 'reports',
    name: 'Reports'
  },
  {
    path: '/reports/type',
    Comp: <Reports />,
    routeName: 'reports',
    name: 'Reports'
  }
];
